import { Stack } from '@mui/material';
import { getBlacklist } from 'lib/api/blackList';
import { getEconomicActivitiesBlacklist } from 'lib/api/economicActivitiesBlacklist';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import Business from './Components/Business';
import EconomicActivities from './Components/EconomicActivities';

const BlackList = () => {
  const dispatch = useDispatch();
  const [businessIdentifier, setBusinessIdentifier] = useState('');
  const { isPending: isPendingBlacklist } = getBlacklist(
    dispatch,
    businessIdentifier,
  );
  const { isPending: isPendingActivities } =
    getEconomicActivitiesBlacklist(dispatch);

  const isPending = isPendingBlacklist || isPendingActivities;

  if (isPending) return <CenteredCircularProgress type="layout" />;

  return (
    <Stack direction="column" gap={6}>
      <Business
        businessIdentifier={businessIdentifier}
        setBusinessIdentifier={setBusinessIdentifier}
      />
      <EconomicActivities />
    </Stack>
  );
};

export default BlackList;
